import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FormsComponent } from './forms.component';

import { FormsFormComponent } from './forms-form/forms-form.component';
import { FormsBuilderPolishedComponent } from './forms-builder-polished/forms-builder-polished.component';
import { FormFinderComponent } from './forms-builder-polished/form-finder/form-finder.component';
import { ParagraphBuilderComponent } from './forms-builder-polished/paragraph-builder/paragraph-builder.component';

const routes: Routes = [{
  path: '', component: FormsComponent,
  children: [
    { path: 'form', component: FormsFormComponent },
    {
      path: 'builder',
      children: [
        { path: '', redirectTo: 'finder', pathMatch: 'full' },
        { path: 'finder', component: FormFinderComponent },
        { path: 'editor/:formId/:versionId/:mode', component: ParagraphBuilderComponent },
        { path: 'legacy', component: FormsBuilderPolishedComponent }
      ]
    }
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormsRoutingModule { }
